module.exports = __webpack_public_path__ + "img/create_success.af090c81.svg";